import { useMutation } from '@tanstack/react-query';
import uploadsApiClient, {
  UploadFileInput,
  UploadResponse,
} from '../../api/uploads';
import { KlydoError } from '../../hooks/types';

const useUploadStrikeMutation = () => {
  return useMutation<UploadResponse, KlydoError, UploadFileInput>({
    mutationFn: (input: UploadFileInput) =>
      uploadsApiClient.uploadStrike(input),
  });
};

export default useUploadStrikeMutation;
